import { useEffect, useMemo, useState } from "react";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useToast } from "../../components/ui/Toast";
import { useGetManagedGroupsQuery } from "../../api/managementApi";
import GroupListPanel from "./components/GroupListPanel";
import GroupDetailPanel from "./components/GroupDetailPanel";
import CreateGroupModal from "../management/components/CreateGroupModal";

/**
 * Grup yönetimi: yönettiğin grupları görüntüleme, üye/yönetici yönetimi,
 * üye hedeflerini düzenleme, ilerleme istatistikleri, QR şablonları ve grup
 * oluşturma tek sayfada. Solda grup listesi, sağda seçili grubun sekmeli detayı.
 *
 * Liste yalnızca yönetici olunan grupları gösterir — üye olarak katıldığın
 * gruplarda yönetim ekranının göstereceği bir şey yok.
 */
export default function GroupListPage() {
  const { t } = useScriptMode();
  const toast = useToast();

  const { data, isLoading, refetch } = useGetManagedGroupsQuery();
  // Sunucu bu ucu `data.managedGroups` altında döndürüyor.
  const groups = useMemo(() => data?.data?.managedGroups || [], [data]);

  const [selectedId, setSelectedId] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);

  // İlk grubu seç; seçili grup listeden düşerse (silme) seçimi tazele.
  useEffect(() => {
    if (groups.length === 0) {
      setSelectedId(null);
      return;
    }
    const stillThere = groups.some((g) => String(g.id) === String(selectedId));
    if (!stillThere) setSelectedId(String(groups[0].id));
  }, [groups, selectedId]);

  const selected = groups.find((g) => String(g.id) === String(selectedId)) || null;

  return (
    <div className="w-full flex flex-col gap-6 lg:h-full lg:min-h-0">
      <div className="tk-stagger grid grid-cols-1 lg:grid-cols-[340px_minmax(0,1fr)] gap-6 items-start lg:items-stretch lg:flex-1 lg:min-h-0">
        <GroupListPanel
          groups={groups}
          selectedId={selectedId}
          loading={isLoading}
          onSelect={setSelectedId}
          onCreate={() => setCreateOpen(true)}
        />

        <GroupDetailPanel group={selected} onDeleted={() => { setSelectedId(null); refetch(); }} />
      </div>

      <CreateGroupModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={() => {
          toast.success(t("manage_create_success"));
          refetch();
        }}
      />
    </div>
  );
}
